import SoundManager from "../../../../../lib/html5-software-library/src/ranj/audio/SoundManager";
import RevisableLanguagePack from "../../../../../lib/html5-software-library/src/ranj/language/RevisableLanguagePack";
import AssetLibrary from "../../../core/assetloading/AssetLibrary";
import AssetLoadService from "../../../core/assetloading/AssetLoadService";
import AbstractMediator from "../../../core/ui/AbstractMediator";
import NPCModel from "../../scenario/NPCModel";
import EmailModel from "../model/EmailModel";
import { isNull } from "/lib/html5-software-library/src/ranj/util/TypeUtil";
import Handlebars from "handlebars";
import NGTVariableManager from "../../base/NGTVariableManager";

export default class EmailReceivedItemMediator extends AbstractMediator {
    /**
     * @constructor
     * @param {createjs.MovieClip} target 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {RevisableLanguagePack} languagePack 
     * @param {SoundManager} soundManager 
     * @param {EmailModel} emailModel 
     * @param {NPCModel} npcModel 
     * @param {AssetLibrary} assetLibrary 
     * @param {AssetLoadService} assetLoadService 
     * @param {NGTVariableManager} variableManager 
     */
    constructor(target, dispatcher, languagePack, soundManager, emailModel, npcModel, assetLibrary, assetLoadService, variableManager) {
        super(target, dispatcher);

        this._languagePack = languagePack;
        this._soundManager = soundManager;
        this._emailModel = emailModel;
        this._npcModel = npcModel;
        this._assetLibrary = assetLibrary;
        this._assetLoadService = assetLoadService;
        this._variableManager = variableManager;

        this._item = this.getCustomData().item;
    }

    initialize() {
        super.initialize();

        this._target.toLabelTextField.text = this._languagePack.getText("email.receiverLabel");
        this._target.subjectLabelTextField.text = this._languagePack.getText("email.subjectLabel");

        this._contentTextField = this._target.bodyTextField;

        // Load image
        const sender = this._item.content.getSender();
        const npc = this._npcModel.getNpcByNpcID(sender);
        if (npc) {
            const npcImage = npc.getImage();
            if (npcImage) {
                this._loadAndShowImage(npcImage, `assets/images/npcs/${npcImage}.png`);
            }
        }

        this.update();
    }

    destroy() {

        this._item = null;

        super.destroy();
    }

    update() {
        const sender = this._item.content.getSender();
        this._target.nameTextField.text = this._npcModel.getDisplayNameForNpcId(sender);

        const recipients = this._item.content.getRecipients();
        const recipientNames = recipients.map(r => this._npcModel.getDisplayNameForNpcId(r));
        this._target.toTextField.text = isNull(recipientNames) ? "" : recipientNames.join(", ");

        this._target.subjectTextField.text = (isNull(this._item.content.getSubject()) ? "" : this._item.content.getSubject());

        const content = this._item.content.getContent();
        if (content) {
            // Converts email body field into a handlebars template and passes the story variables as data
            const contentTemplate = Handlebars.compile(content);
            const storyVariables = this._variableManager.getState();
            this._contentTextField.text = contentTemplate(storyVariables);
        } else {
            this._contentTextField.text = "";
        }

        var margin = this._target.nameTextField.y;
        var targetHeight = this._contentTextField.y + this._contentTextField.getBounds().height + margin;
        var currBounds = this._target.background.getBounds();
        this._target.background.scaleY = targetHeight / currBounds.height;

        this._target.setBounds(currBounds.x, currBounds.y, currBounds.width, targetHeight);
    }

    _loadAndShowImage(id, url) {
        if (this._assetLibrary.hasAsset(id)) {
            this._onImageLoaded(id, false);
            return;
        }

        this._assetLoadService.lazyLoadImage(id, url, this._onImageLoaded.bind(this));
    }

    _onImageLoaded(assetId, animated = true) {
        const image = this._assetLibrary.getAsset(assetId);
        const bitmap = new createjs.Bitmap(image);
        this._target.imageContainer.addChild(bitmap);

        if (animated) {
            bitmap.alpha = 0;

            createjs.Tween.get(bitmap)
                .to({ alpha: 1 }, 150, createjs.Ease.sineInOut)
                .call(() => {
                    this._target.noPortraitThumb.visible = false;
                });
        } else {
            this._target.noPortraitThumb.visible = false;
        }
    }
}